import { bool, array, func, object, string } from 'prop-types';
import useSubTabs from '../hooks/useSubTabs';
import SubTabHeader from './SubTabHeader';
import SubTabList from './SubTabList';
import SubTabButtons from './SubTabButtons';
import Collapse from '@mui/material/Collapse';
import sty from '../styles/SubTabs.module.css';
import LoadingBackdrop from 'components/LoadingBackdrop';

/**
 * @component SubTabs
 * @param { Object[] } props
 * @param { boolean } props.open
 * @param { string } props.groupId
 * @param { string } props.subtabId
 * @param { array } props.tabs
 * @param { array } props.subtabs
 * @param { function } props.onMenu
 * @param { object } props.savingState
 * @param { object } props.savingHandler
 * @param { array } props.groupTabs
 * @param { object } props.handleSubtab
 * @returns { JSX.Element }
 */
function SubTabs(props) {
	const { state, handler } = useSubTabs(props);

	return (
		<Collapse className={sty.subtabs_collapse} in={props.open} timeout="auto" unmountOnExit>
			<section className={sty.subtabs_section}>
				<SubTabHeader
					options={state.filteredSubtabs}
					isDisabled={state.isDisabled}
					selected={state.chosenOptions}
					onOptions={handler.onOptions}
					onAdd={handler.onAdd}
					onDelete={handler.onDelete}
				/>
				<SubTabList
					isCheckAll={state.isCheckAll}
					groupSubtabs={state.groupSubtabs}
					isLoading={state.isLoading}
					onCheck={handler.onCheck}
					onCheckAll={handler.onCheckAll}
					onHandle={handler.onHandle}
					onSetSubtabs={handler.onSetSubtabs}
				/>
				<SubTabButtons onSave={handler.onSave} onReset={handler.onReset} />
				<LoadingBackdrop open={state.loading} />
			</section>
		</Collapse>
	);
}

SubTabs.propTypes = {
	open: bool,
	groupId: string,
	subtabId: string,
	tabs: array,
	subtabs: array,
	onMenu: func,
	savingState: object,
	savingHandler: object,
	groupTabs: array,
	handleSubtab: object,
};

export default SubTabs;
